import React, { useEffect, useState } from "react";
import Header from "../../../Componets/Header";
import { useLocation } from "react-router-dom";
import products from "../../../Data/products.json";
import units from "../../../Data/units.json";
import categories from "../../../Data/category.json";
import brands from "../../../Data/brands.json";
import toast from "react-hot-toast";
import Loadercomponent from "../../../Componets/Loader";
import { get_all_products_reports } from "../../../Controllers/Dashboard/Dashboard";
import ReactToPrint from "react-to-print";
import { Button } from "antd";
import { PrinterOutlined } from "@ant-design/icons";
import { useRef } from "react";
import Table from "../../../Componets/Table";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { registerCairoFont } from "../../Reports/cairo-font";

const ProductReportDashboard = () => {
  let componentRef = useRef();
  let location = useLocation();

  const [loader, setLoader] = useState(false);
  const [body, setBody] = useState();
  const [total, setTotal] = useState();
  const [role, setRole] = useState("");
  const [pagination, setPagination] = useState({
    currentPage: 1,
    totalPages: 0,
    totalCount: 0
  });

  const Dashboard_Branch = localStorage.getItem("Dashboard_Branch");

  const tables = [
    { name: "Name", key: "Name" },
    { name: "Units", key: "Units" },
    { name: "Category", key: "Category" },
    { name: "Brands", key: "Brands" },
    { name: "Branch", key: "Branch" },
    { name: "Stock", key: "Stock" },
  ];

  const headers = {
    name: "Products",
    components: [
      {
        type: "search",
        name: "search",
        placeholder: "Search",
        value: "",
      },
      {
        type: "select",
        name: "sort",
        placeholder: "Sort",
        allowClear: true,
        showSearch: false,
        filterOption: true,
        value: null,
        options: [
          { value: 0, label: "Name (A-Z)" },
          { value: 1, label: "Name (Z-A)" },
          { value: 2, label: "Stock (Low)" },
          { value: 3, label: "Stock (High)" },
        ],
      },
      {
        type: "filter",
        name: "unit",
        allowClear: true,
        showSearch: true,
        filterOption: false,
        placeholder: "Units",
        api: "get-all-product-units",
        value: null,
        options: null,
      },
      {
        type: "filter",
        name: "category",
        placeholder: "Category",
        allowClear: true,
        showSearch: true,
        filterOption: false,
        api: "get-all-product-categories",
        value: null,
        options: null,
      },
      {
        type: "filter",
        name: "brand",
        placeholder: "Brands",
        allowClear: true,
        showSearch: true,
        filterOption: false,
        api: "get-all-product-brands",
        value: null,
        options: null,
      },
      {
        type: "filter",
        name: "type",
        placeholder: "Type",
        value: null,
        allowClear: true,
        showSearch: false,
        filterOption: true,
        options: [
          { value: 0, label: "Non-Stockable" },
          { value: 1, label: "Stockable" },
        ],
      },
      // {
      //   type: "filter",
      //   name: "status",
      //   placeholder: "Status",
      //   value: null,
      //   allowClear: true,
      //   showSearch: false,
      //   filterOption: true,
      //   options: [
      //     { value: "0", label: "Inactive" },
      //     { value: "1", label: "Active" },
      //   ],
      // },
    ],
    navigate: {
      tabs: [
        {
          name: "Dashboard",
          path: "/app/dashboard",
        },
      ],
    },
  };

  const [header, setHeader] = useState(headers);

  const formdata = (data) => {
    let page = data?.search ? pagination?.currentPage : 1;

    fetchData({
      ...data,
      currentPage: page,
      totalCount: pagination?.totalCount,
      totalPages: pagination?.totalPages,
    });
  };

  const paginationdata = (data) => {
    let headerdata = {};

    header?.components?.map((value, index) => {
      headerdata[value.name] = value.value;
    });

    fetchData({
      ...data,
      search: headerdata?.search,
      sort: headerdata?.sort,
      unit: headerdata?.unit,
      category: headerdata?.category,
      brand: headerdata?.brand,
      type: headerdata?.type,
      status: headerdata?.status,
      branch: headerdata?.branch,
    });
  };

  const fetchData = async (tabledata) => {
    try {
      setLoader(true);

      const data = {
        search: tabledata?.search,
        sort: tabledata?.sort,
        unit: tabledata?.unit,
        category: tabledata?.category,
        brand: tabledata?.brand,
        type: tabledata?.type,
        status: tabledata?.status,
        branch: tabledata?.branch ? tabledata?.branch : Dashboard_Branch,
        page: tabledata?.currentPage || 1,
        limit: 50,
      };

      const productsResponse = await get_all_products_reports(data);


      if (productsResponse?.status) {
        const tableData = productsResponse?.data?.data?.map((product, index) => {
          return {
            Name: product?.name || "-",
            Units: product?.unit?.name || "-",
            Category: product?.category?.name || "-",
            Brands: product?.brand?.name || "-",
            Branch: product?.branch?.name || "-",
            Stock: product?.total_inventory ? parseFloat(product.total_inventory).toFixed(3) : "0.000"
          };
        }) || [];

        setBody(tableData);
        setRole(productsResponse?.data?.role)
        setTotal(productsResponse?.data?.grand_total_inventory || 0);

        setPagination({
          currentPage: productsResponse?.data?.currentPage || 1,
          totalPages: productsResponse?.data?.totalPages || 0,
          totalCount: productsResponse?.data?.totalCount || 0
        });

        setLoader(false);
      } else {
        toast?.error(productsResponse?.message);
        setLoader(false);
      }
    } catch (errors) {
      toast?.error(errors?.message);
      setLoader(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);


  const fetchAllProducts = async () => {
    try {
      const headerdata = {};
      header?.components?.map((value, index) => {
        headerdata[value.name] = value.value;
      });

      const data = {
        search: headerdata?.search,
        sort: headerdata?.sort,
        unit: headerdata?.unit,
        category: headerdata?.category,
        brand: headerdata?.brand,
        type: headerdata?.type,
        status: headerdata?.status,
        branch: headerdata?.branch ? headerdata?.branch : Dashboard_Branch,
        source: "Product_Report"
      };

      const response = await get_all_products_reports(data);
      return response?.status ? response?.data?.data : [];
    } catch (error) {
      toast.error("Failed to fetch products for download");
      return [];
    }
  };


  const downloadCSV = async () => {
    try {
      const allProducts = await fetchAllProducts();

      if (!allProducts || allProducts.length === 0) {
        toast.error("No data available to download");
        setLoader(false);
        return;
      }

      const headers = ["S.No", "Name", "Units", "Category", "Brands", "Branch", "Stock"];

      const csvContent = [
        headers.join(","),
        ...allProducts.map((product, index) => [
          index + 1,
          `"${product?.name || ""}"`,
          `"${product?.unit?.name || ""}"`,
          `"${product?.category?.name || ""}"`,
          `"${product?.brand?.name || ""}"`,
          `"${product?.branch?.name || ""}"`,
          product?.total_inventory ? parseFloat(product.total_inventory).toFixed(3) : "0.000"
        ].join(","))
      ].join("\n");

      const encoder = new TextEncoder();
      const encodedContent = encoder.encode('\uFEFF' + csvContent);

      const blob = new Blob([encodedContent], { type: 'text/csv;charset=utf-8' });

      const link = document.createElement("a");
      const url = URL.createObjectURL(blob);

      link.setAttribute("href", url);
      link.setAttribute("download", `Products_Report_${new Date().toLocaleDateString().replace(/\//g, '_')}.csv`);
      link.style.visibility = 'hidden';

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);

    } catch (error) {
      console.error("Error generating CSV:", error);
      toast.error("Failed to generate CSV file");
    }
  };

  const downloadPDF = async () => {
    try {
      const allProducts = await fetchAllProducts();

      if (!allProducts || allProducts.length === 0) {
        toast.error("No data available to download");
        setLoader(false);
        return;
      }

      const doc = new jsPDF({
        orientation: "landscape",
        unit: "mm",
        format: "a4",
      });

      registerCairoFont(doc);
      const pageWidth = doc.internal.pageSize.getWidth();

      doc.setFont("Cairo-Bold", "bold");

      doc.setFontSize(18);
      doc.text("Products Report", pageWidth / 2, 18, { align: "center" });

      const now = new Date();
      const formattedDate = now.toLocaleDateString("en-GB");
      const formattedTime = now.toLocaleTimeString();
      doc.setFontSize(10);
      doc.text(`Downloaded on: ${formattedDate} ${formattedTime}`, pageWidth / 2, 26, { align: "center" });

      const tableRows = allProducts.map((product, index) => [
        index + 1,
        product?.name || "-",
        product?.unit?.name || "-",
        product?.category?.name || "-",
        product?.brand?.name || "-",
        product?.branch?.name || "-",
        product?.total_inventory ? parseFloat(product.total_inventory).toFixed(3) : "0.000"
      ]);

      autoTable(doc, {
        startY: 32,
        head: [["S.No", "Name", "Units", "Category", "Brands", "Branch", "Stock"]],
        body: tableRows,
        styles: {
          font: "Cairo",
          textColor: [0, 0, 0],
          lineColor: [222, 222, 222],
          fillColor: false,
          lineWidth: 0.2
        },
        headStyles: {
          font: "Cairo",
          fontStyle: "bold",
          fillColor: false,
          lineColor: [222, 222, 222],
          lineWidth: 0.2
        },
        alternateRowStyles: {
          fillColor: false,
        }
      });

      doc.autoPrint();

      const branchName = allProducts?.[0]?.branch?.name || "Products";

      doc.save(`${branchName}-products.pdf`);

    } catch (error) {
      console.error("Error generating PDF:", error);
      toast.error("Failed to generate PDF file");
    }
  };

  return (
    <Header headers={header} setHeaders={setHeader} formdata={formdata}>
      <Loadercomponent loader={loader}>
        <div className="text-right flex gap-3 justify-end">
          <div className="w-[8.27in] text-right py-4">
            <Button
              className="mr-2 !bg-[#0dacce] !border-[#0dacce] hover:!bg-[#0b9abb] hover:!border-[#0b9abb]"
              type="primary"
              onClick={downloadCSV}
            >
              Download CSV
            </Button>
            <Button
              className="mr-2 !bg-[#0dacce] !border-[#0dacce] hover:!bg-[#0b9abb] hover:!border-[#0b9abb]"
              type="primary"
              onClick={downloadPDF}
            >
              Download PDF
            </Button>
          </div>
        </div>
        <Table
          head={tables}
          body={body}
          pagination={pagination}
          paginationdata={paginationdata}
          componentRef={componentRef}
          summary={1}
        />
      </Loadercomponent>
    </Header>
  );
};

export default ProductReportDashboard;
